<template>
    <div class="sfz-father">
        <p class="nav-box">
            <span class="title">武汉居住证</span>
            <span class="refresh" @click="getIdCard(true)">更新信息</span>
        </p>
        <div class="sfz-box-w">
            <div class="electronic-certificate-box sfz-box box-shadow">
                <div class="info-top-box">
                <p class="section">
                    <span class="label">姓 名：</span>
                    <span class="content">{{ idCard.XM }}</span>
                </p>
                <div class="section-box">
                    <p class="section">
                        <span class="label" style="display: inline-block;">性 别：</span>
                        <span class="content">{{ idCard.XB }}</span>
                    </p>
                    <p class="section">
                        <span class="label" style="font-size: 12px;width: 75px">民 族：</span>
                        <span class="content">{{ idCard.MZ }}</span>
                    </p>
                </div>
                <p class="section address-box">
                    <span class="label" >证件编号：</span>
                    <span class="content">{{idCard.ZJHM}}</span>
                </p>
                <p class="section address-box">
                    <span class="label">身份证号码：</span>
                    <span class="content">{{idCard.SFZHM}}</span>
                </p>
                <p class="section address-box">
                    <span class="label">户籍所在地：</span>
                    <span class="content address-content">{{idCard.HJDZ}}</span>
                </p>
                </div>
                <div class="info-bottom-box" style="margin-top: 17px;">
                <p class="section address-box address-bottom-box" style="width: 340px;">
                    <span class="label">现居住地址：</span>
                    <span class="content address-content" style="width: 265px;">{{idCard.XZZ}}</span>
                </p>
                <p class="section address-box">
                    <span class="label">有效期限：</span>
                    <span class="content">
                    <span class="content">{{ idCard.JZZYXQSRQ }}</span>
                        <span class="label">至</span>
                          <span class="content">{{ idCard.JZZYXJZRQ }}</span>
                    </span>
                </p>
                </div>
                <img class="photo" :src="`data:image/png;base64,${idCard.ZP}`" alt="照片">
            </div>
            <div class="electronic-certificate-box sfz-box sfz-box-two box-shadow">
                <!--                <p class="issue-organ">{{idCard.CZRKQFJG}}</p>-->
                <!--                <p class="date">{{idCard.CZRKYXQXQSRQ}}-{{idCard.CZRKYXQXJZRQ}}</p>-->
            </div>
        </div>
        <div v-show="dataShow">
            <div class="btn-dzzz">
                <img @click="showQrCode" src="~@public/img/user/electronicCertificate/sfz_btn.png"/>
                <!--<img @click="toRealAuthentication" src="~@public/img/user/electronicCertificate/sfz_btn2.png"/>-->
            </div>
            <van-dialog v-model="qrcodeShow" :showConfirmButton="false" class="dialog-demo sfz">
                <div class="dialog-main">
                    <h3>武汉电子居住证二维码</h3>
                    <div class="ewm-w">
                        <img :src="qrcode">
                        <p>证照核验识别二维码</p>
                    </div>
                </div>
                <div class="btn-ewm" @click="qrcodeShow=false">确 认</div>
            </van-dialog>
            <van-dialog v-model="randomCodeShow" :showConfirmButton="false" class="dialog-demo sfz">
                <div class="dialog-main">
                    <h3>身份证随机码</h3>
                    <div class="ewm-w">
                        <span>{{ randomCode }}</span>
                    </div>
                </div>
                <div class="btn-ewm" @click="randomCodeShow=false">确 认</div>
            </van-dialog>
        </div>

        <!--<div style="text-align: center;margin-top: 3.5rem;">-->
        <!--<van-button @click="wangba" type="info">电子证件二维码</van-button>-->
        <!--</div>-->

        <!--<van-dialog v-model="show"  class="dialog-demo">-->
        <!--<p style="text-align: left;margin-top: 10px;padding-left: 15px">二维码信息：</p>-->
        <!--<div class="img-box">-->
        <!--<img :src="qrcode" style="width: 100%">-->
        <!--</div>-->
        <!--<p style="text-align: left;padding: 0 15px">1.该二维码仅限湖北省已开通身份证电子凭证核实业务的酒店使用</p>-->
        <!--<p style="text-align: left;margin-top: 5px;padding: 0 15px;margin-bottom: 20px">2.请入住前向前台出示本二维码</p>-->
        <!--</van-dialog>-->
    </div>
</template>

<script>

    import {Button, Toast, CellGroup, Dialog, Cell, Field, Popup, Picker, Checkbox, AddressEdit, Area} from 'vant'
    import {queryApiMap} from "@/api/query";
    import {getToken} from "@/utils/auth"

    export default {
        components: {
            [Dialog.Component.name]: Dialog.Component,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Checkbox.name]: Checkbox,
            [Popup.name]: Popup,
            [Cell.name]:Cell,
            [AddressEdit.name]:AddressEdit,
            [Area.name]:Area,
        },
        data() {
            return {
                qrcodeShow: false,
                randomCodeShow: false,
                idCard: {},
                qrcode: '',
                randomCode: '',
                dataShow: false,
                userInfo: {}, // 存放cookie中获取的个人信息
            };
        },
        beforeRouteLeave(to, from, next) {
            if (to.path === '/sign-up/login' && this.$store.state.loginStatus) {
                next('/electronicCertificate')
            }
            next()
        },
        mounted() {
            //获取居民身份证信息
            this.getIdCard(true)
            this.getLoginInfo()
            this.logger.visit('703 ', '1')
        },
        methods: {
            getQueryString(name, url) {
                return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
            },
            getLoginInfo: function () {
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                }
            },
            showQrCode: function () {
                const data = {
                    permitType: '09' // 证照类型
                }
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                })
                this.$httpUtils.getGatewayUtils(queryApiMap.qrcode, data).then(res => {
                    if (res.data.succ) {
                        this.qrcode = 'data:image/png;base64,' + res.data.data;
                        Toast.clear()
                        this.qrcodeShow = true
                    } else {
                        Toast.fail(res.data.msg)
                    }
                }).catch(error => {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(error)
                })
            },
            /**
             * 跳转外部实人认证
             */
            async toRealAuthentication() {
                const token = getToken('access_token')
                if (!this.userInfo.guid || !token) {
                    Dialog.alert({
                        message: '请先登录'
                    })
                    return false
                }
                window.sessionStorage.setItem('operateType', 'getRandom')
                //const res = await this.$httpUtils.getGatewayUtils(`${memberApi.genToken}`)
                let redirect = this.$route.path
                window.location.href = `${global.realAuthenticationUrl}?token=${token}&redirect=${redirect}`
                window.sessionStorage.setItem('redirect', redirect)
                // window.location.href = `${global.realAuthenticationUrl}?guid=${this.userInfo.guid}&redirect=${this.$route.path}`
            },
            showRandomCode() {
                const data = {
                    permitType: '09' // 证照类型
                }
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                })
                this.$httpUtils.getGatewayUtils(queryApiMap.randomCode, data).then(res => {
                    if (res.data.succ) {
                        this.randomCode = res.data.data;
                        Toast.clear()
                        this.randomCodeShow = true
                    } else {
                        Toast.fail(res.data.msg)
                    }
                }).catch(error => {
                    // Toast.fail('服务器运行失败，请稍后再试。')
                    Toast.fail('服务停止运行，给您带来的不便进请原谅！')
                    console.log(error)
                })
            },
            /**
             * 获取居民身份证信息
             */
            getIdCard(refresh) {
                const data = {
                    permitType: '09', // 证照类型
                    refresh: refresh // 是否刷新数据  true/false
                }

                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                })

                this.$httpUtils.getGatewayUtils(queryApiMap.electronicPermit, data).then(res => {
                    if (res.data.succ) {
                        this.dataShow = true
                        this.idCard = res.data.data.row
                        console.log(this.idCard)
                        // if (this.idCard.CZRKYXQXQSRQ) {
                        //     this.idCard.CZRKYXQXQSRQ = this.idCard.CZRKYXQXQSRQ.substring(0, 10);
                        // }
                        // if (this.idCard.CZRKYXQXJZRQ) {
                        //     this.idCard.CZRKYXQXJZRQ = this.idCard.CZRKYXQXJZRQ.substring(0, 10);
                        // }
                        Toast.clear()
                        if (this.getQueryString('operateType', window.location.href) === 'getRandom') {
                            this.showRandomCode()
                        }
                    } else {
                        Toast.clear()
                        Dialog.alert({
                            title: '提示信息',
                            message: `${res.data.msg}`
                        }).then(() => {
                            this.$router.push('/')
                        })
                    }
                }).catch(error => {
                    this.idCard = {};
                    // Toast.fail('服务器运行失败，请稍后再试。')
                    Toast.fail('服务停止运行，给您带来的不便进请原谅！')
                    console.log(error)
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/user/electronicCertificate/reset.less";
    @import "~@assets/css/views/user/electronicCertificate/IdCard.less";

    /*.van-dialog{*/
    /*top:48%;*/
    /*width: 74%;*/
    /*}*/
    .refresh {
        flex: 1;
        color: #5bade7;
        text-align: right;
        cursor: pointer;
    }


    .sfz-box {
        border-radius: 6px;
        /*height: 5.2rem;*/
        background: url("~@public/img/user/electronicCertificate/whdzjmz.png") no-repeat -10px -8px;
        background-size: 102% 104%;
    }

    .electronic-certificate-box .section .label {
        color: #000;
        width: 130px;
        text-align-last: justify;
        text-align: justify;
        text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 5px;
        word-break: keep-all; /* 不换行 */
        white-space: nowrap; /* 不换行 */
    }

    .electronic-certificate-box .section .mg-r-10 {
        margin-right: 0;
    }

    .electronic-certificate-box .section span {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
    }

    .sfz-box .photo {
        width: 168px;
        height: 190px;
    }

    .sfz-box.sfz-box-two {
        background: url("~@public/img/user/electronicCertificate/whsjzz.png") no-repeat -7px -7px;
        background-size: 102% 104%;
    }

    .electronic-certificate-box .section.address-box .content {
        letter-spacing: 1px;
        width: 72%;
    }

    .address-bottom-box {

    }

    .electronic-certificate-box .section{
        display: flex;
         margin-bottom: 2px;
    }

    .electronic-certificate-box .info-top-box .section {
        margin-bottom: 21px;
    }

    .electronic-certificate-box  .address-bottom-box .section {
        margin-bottom: 0px !important;
    }

    .info-top-box {
        margin-top: -30px !important;
    }

    .info-bottom-box {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-top: 40px;
        height: 80px;
    }

</style>
